<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as DOCUMENT_TYPE_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'DocumentTypeCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: DOCUMENT_TYPE_TYPES.GENERIC.document.documenttype.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...DOCUMENT_TYPE_TYPES.GENERIC.document.documenttype.LIST.ACTIONS
    })
  }
}
</script>
